import React from "react"
import { ITextProps } from "../../types/textTypes"
import mapStylesFromProps from "../../utils/mapStylesFromProps"

interface Props extends ITextProps {}

const Figure = (props: Props) => {
  const className = `font-raleway-extralight text-[8px] sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl ${mapStylesFromProps(
    props
  )}`
  return <span className={className}>{props.children}</span>
}

export default Figure
